import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { UserResponseTypes } from "../common/response.common";
import { asUpdateHook, get, post, postEmpty } from "./common";

export const user = {
    profile() {
        return get<UserResponseTypes.Profile>(`/user/profile`);
    },
    profileSettings() {
        return get<UserResponseTypes.ProfileSettings>(`/user/profile-settings`);
    },
    updatePassword(data: typeof Requests.User.UpdatePassword.Input) {
        return post<typeof data>(`/user/update-password`, data);
    },
    generateOTP() {
        return postEmpty<UserResponseTypes.GenerateOTP>(`/user/generate-otp`);
    },
    record(data: typeof Requests.User.Record.Input) {
        return post<typeof data, UserResponseTypes.Record>(`/user/record`, data);
    },
    masquerade(userId: string) {
        return get<UserResponseTypes.Masquerade>(`/user/masquerade/${userId}`);
    },
    recreateAvatar(userId: string, data: typeof Requests.User.RecreateAvatar.Input) {
        return post<typeof data>(`/user/recreate-avatar/${userId}`, data);
    },
    formHooks: {
        update(isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.User.Update.Input) => {
                return await asUpdateHook(post<typeof data>(`/user/update`, data), isLoading);
            };
        },
    },
};
